<script setup>
	import { ref, reactive, computed, onMounted } from 'vue'
	import Header from './components/Header.vue'
	import Main from './components/Main.vue'
	import Footer from './components/Footer.vue'
	import Spinner from './components/Spinner.vue'
	import Thankyou from './components/Thankyou.vue'
	import { setCookie, getCookie, advertiserMapping } from './constants/selectOptions.js'
	import { sendToEzsend } from './utilities/phoneUtilities.js'
	import axios from 'axios'
	import qs from 'qs';
	import { bsLog, bsEnable, buildFormPayload } from "./utilities/bsLogger";

	window.__bsLogTest = () => bsLog("dev.ping", { hello: "world" });
	const isYahooEmail = (email) => /@yahoo\.com$/i.test((email || '').trim());

	let backupCity = null;
	let backupState = null;
	let backupZip = null;
	let LpRequestId = null;

	// split test variables
	let mainHeadline = "Consolidate Your Debt Into One Low Monthly Payment";
	let mainSubHeadline = "Your search for debt relief begins here!"
	let variantName = "FFAPP-CONTROL"

	const variants = {
		questionStyle: ['range', 'buttons'],
		buttonStyle: ['v1', 'v2'],
		tooltip: ['on', 'off']
	};

	function generateUUIDFallback() {
		// RFC4122 version 4 UUID polyfill
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
			const r = Math.random() * 16 | 0;
			const v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);
		});
	}
	function getOrCreateSessionId() {
		const key = 'session_id';
		let sessionId = localStorage.getItem(key);

		if (!sessionId) {
			if (window.crypto?.randomUUID) {
				sessionId = crypto.randomUUID();
			} else {
				sessionId = generateUUIDFallback();
			}
			localStorage.setItem(key, sessionId);
		}

		return sessionId;
	}
	function getOrCreateVariant() {
		const key = 'landingPageVariant';
		let variant = localStorage.getItem(key);
		if (variant) return JSON.parse(variant);

		// const rand = Math.floor(Math.random() * 8);
		// const assigned = {
		// 	questionStyle: variants.questionStyle[(rand >> 2) & 1],
		// 	buttonStyle: variants.buttonStyle[(rand >> 1) & 1],
		// 	tooltip: variants.tooltip[rand & 1]
		// };

		const allowed = [
			{ questionStyle: 'range',   buttonStyle: 'v1', tooltip: 'off' }, // range-v1-off
			{ questionStyle: 'buttons', buttonStyle: 'v1', tooltip: 'off' } // buttons-v1-off
		];

		const assigned = allowed[Math.floor(Math.random() * allowed.length)];

		localStorage.setItem(key, JSON.stringify(assigned));
		return assigned;
	}

	let sessionId = getOrCreateSessionId();
	const userVariant = getOrCreateVariant();
	console.log(userVariant);
	const variantId = `${userVariant.questionStyle}-${userVariant.buttonStyle}-${userVariant.tooltip}`;
	const TRACKING_ENDPOINT = 'https://oqsf6awdaglglx6knym6hyquqm0nmtmh.lambda-url.us-east-2.on.aws/';
	async function trackEvent({ eventType, sourceId = null, metadata = {} }) {
		try {
			await axios.post(TRACKING_ENDPOINT, {
				session_id: sessionId,
				event_type: eventType,
				variant_id: variantId,
				source_id: sourceId,
				metadata: {
					...metadata,
					user_agent: navigator.userAgent,
					screen_width: window.innerWidth,
					referrer: document.referrer,
					timestamp: new Date().toISOString()
				}
			});
		} catch (err) {
			console.error('Tracking event failed:', err);
		}
	}

	function trackInitialImpressionOnce(formData) {
		const impressionKey = 'initial_impression_sent';

		if (!localStorage.getItem(impressionKey)) {
			// trackEvent({
			// 	eventType: 'initialImpression',
			// 	sourceId: formData.aff_id
			// });

			localStorage.setItem(impressionKey, 'true');
		}
	}

	let showArrayDisclaimer = false

	let acContactId = null
	let lpLeadId = null
	const questionOrder = ref([
		'amount',
		'employed',
		'income',
		'realEstate',
		'name',
		'email',
		'address',
		'dob',
		'phone'
	])
	let arrayData = {
		collections: null,
		credit_score: null,
		delinquencies: null,
		total_unsecured_debt: null,
		tax_liens: null,
		open_student_loan_bal: null
	}
	let readyToRedirect = true
	const formatter = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0
	});
	const params = new URLSearchParams(window.location.search)
	const EMP_MODE = /^(1|true|yes)$/i.test(params.get('emp') || '')
	let phoneFromParams = (() => {
		let phone = (params.get('phone') || "").replace(/-/g, '');
		if (phone.startsWith('1') || phone.startsWith('+1') || phone.startsWith(' 1')) {
			phone = phone.slice(-10);
		}
		return phone.length === 10 ? phone : null;
	})()
	const questions = ref({
		amount: {
			id: 'amount',
			headline: 'How much debt do you have?',
			showHeadlines: true,
			showProgress: false,
			validated: computed(() => {
				return questions.value.amount.value === null ? false : true
			}),
			type: 'range',
			dollarValue: computed(() => {
				if (questions.value.amount.value === '0') {
					return 'Less than $5,000'
				} else if (questions.value.amount.value === '380') {
					return 'More than $100,000'
				} else {
					var numberValue = 5000 + (questions.value.amount.value * 250)
					return formatter.format(numberValue)
				}
			}),
			numberValue: computed(() => {
				if (questions.value.amount.value === '0') {
					return '0'
				} else if (questions.value.amount.value === '380') {
					return '101000'
				} else {
					return 5000 + (questions.value.amount.value * 250)
				}
			}),
			chat: "<p>Hi there! I'm Catherine, I'm here to help you with your personalized debt savings estimate.</p>",
			value: ref(window.localStorage.getItem("amount") ? JSON.parse(window.localStorage.getItem("amount")) : 62),
			min: 0,
			max: 380,
			backgroundGradientValue: computed(() => {
				var value = ((questions.value.amount.value-questions.value.amount.min)/(questions.value.amount.max-questions.value.amount.min))*100
				return 'linear-gradient(to right, #3C91E6 0%, #3C91E6 ' + value + '%, #eee ' + value + '%, #eee 100%)'
			}),
			submit: (optionValue) => {
				console.log(optionValue)
				localStorage.setItem('amount', optionValue)
				proceed()
			}
		},
		employed: {
			id: 'employed',
			headline: "What's Your Employment Status?",
			showHeadlines: false,
			showProgress: true,
			validated: computed(() => {
				return questions.value.employed.value === null ? false : true
			}),
			type: 'buttons',
			options: [
				{
					text: "Full Time",
					value: "Full Time",
				},
				{
					text: "Part Time",
					value: "Part Time",
				},
				{
					text: "Self Employed",
					value: "Self Employed",
				},
				{
					text: "Retired",
					value: "Retired",
				},
				{
					text: "Unemployed",
					value: "Unemployed",
				}
			],
			chat: "<p>The best consolidation loan option could be different depending on your employment status</p>",
			value: ref(window.localStorage.getItem("employed") ? window.localStorage.getItem("employed") : null),
			submit: (optionValue) => {
				localStorage.setItem('employed', optionValue)
				proceed()
			}
		},
		income: {
			id: 'income',
			headline: 'What is your approximate monthly household income?',
			showHeadlines: false,
			showProgress: true,
			validated: computed(() => {
				return questions.value.income.value === null ? false : true
			}),
			type: 'buttons',
			// When emp=1, show employment statuses that *set* the same income values
			options: (function () {
				// original income choices
				return [
					{ text: '$5000+',          value: '5500' },
					{ text: '$4000 - $5000',   value: '4500' },
					{ text: '$3000 - $4000',   value: '3500' },
					{ text: '$2000 - $3000',   value: '2500' },
					{ text: '$1000 - $2000',   value: '1500' },
					{ text: "I don't have monthly income.", value: '0' },
				]
			})(),
			chat: '<p>Calculate your available gross income including wages, retirement, investments, and rental properties.</p>',
			value: ref(window.localStorage.getItem("income") ? JSON.parse(window.localStorage.getItem("income")) : null),
			submit: (optionValue) => {
				// Store the mapped numeric value as before
				localStorage.setItem('income', optionValue)
				proceed()
			}
		},
		realEstate: {
			id: 'realEstate',
			headline: 'Do you own real estate?',
			showHeadlines: false,
			showProgress: true,
			validated: computed(() => {
				return questions.value.realEstate.value === null ? false : true
			}),
			type: 'buttons',
			options: [
				{
					text: "Yes",
					value: true,
				},
				{
					text: "No",
					value: false,
				}
			],
			chat: "<p>Owning real estate could open up additional loan options which might benefit you.</p>",
			value: ref(window.localStorage.getItem("realEstate") ? JSON.parse( window.localStorage.getItem("realEstate")) : null),
			submit: (optionValue) => {
				localStorage.setItem('realEstate', optionValue)
				proceed()
			}
		},
		name: {
			id: 'name',
			// preHeadline: 'Based on your answers, you could eliminate up to 60% of your debt!',
			// headline: "What's your name?",
			showHeadlines: false,
			showProgress: true,
			validated: computed(() => {
				return (!questions.value.name.first || !questions.value.name.last) ? false : true
			}),
			type: 'name',
			// ✅ Only show the chat if debt > $10k AND income > $2k
			chat: computed(() => {
				const amt = Number(questions.value?.amount?.numberValue ?? 0);
				const inc = Number(questions.value?.income?.value ?? 0); // values like "5500","2500","0"
				return (amt > 10000 && inc > 2000)
					? "<p>Based on your answers, we could help you consolidate your debt into one low monthly payment!</p>"
					: "";
			}),
			first: ref(
				params.get("fname") && params.get("fname") !== "{fname}"
				? params.get("fname")
				: window.localStorage.getItem("firstname") || ""
			),
			last: ref(
				params.get("lname") && params.get("lname") !== "{lname}"
				? params.get("lname")
				: window.localStorage.getItem("lastname") || ""
			),
			submit: () => {
				localStorage.setItem('firstname', questions.value.name.first)
				localStorage.setItem('lastname', questions.value.name.last)
				proceed()

				getLocationData()
			}
		},
		dob: {
			id: 'dob',
			showHeadlines: false,
			showProgress: true,
			validated: computed(() => {
				return (!questions.value.dob.day || !questions.value.dob.month || !questions.value.dob.year) ? false : true
			}),
			type: 'dob',
			chat: "<p>This will help us find specific solutions for you.</p>",
			day: ref(window.localStorage.getItem("day") ? window.localStorage.getItem("day") : ""),
			month: ref(window.localStorage.getItem("month") ? window.localStorage.getItem("month") : ""),
			year: ref(window.localStorage.getItem("year") ? window.localStorage.getItem("year") : ""),
			dayMaskaObject: reactive({}),
			monthMaskaObject: reactive({}),
			yearMaskaObject: reactive({}),
			submit: () => {
				localStorage.setItem('day', questions.value.dob.day)
				localStorage.setItem('month', questions.value.dob.month)
				localStorage.setItem('year', questions.value.dob.year)

				// getArrayData()
				proceed()
			}
		},
		email: {
			id: 'email',
			showHeadlines: false,
			showProgress: true,
			overrideValidation: false,
			validated: computed(() => {
				return !questions.value.email.value ? false : true
			}),
			type: 'email',
			chat: "<p>We'll only send you valuable information related to your needs.</p>",
			value: ref(
				params.get("email") && params.get("email") !== "{email}"
					? params.get("email")
					: window.localStorage.getItem("email") || ""
			),
			sendtoAC: true,
			submit: () => {
				localStorage.setItem('email', questions.value.email.value)
				
				proceed()
			}
		},
		phone: {
			id: 'phone',
			showHeadlines: false,
			showProgress: true,
			overrideValidation: false,
			tcpaLanguage: '',
			validated: computed(() => {
				if (questions.value.phone.overrideValidation) {
					return false
				}
				return (!questions.value.phone.value) ? false : true
			}),
			type: 'contact',
			chat: '<p style="font-weight: 600; margin-top: 9px;">What happens next?</p><ul><li>Your information will be encrypted using 256 SSL technology.</li><li>You&apos;ll be matched with a consolidation loan specialist who will call you to discuss the best options to get to a better financial situation.</li></ul>',
			value: ref(
				phoneFromParams && phoneFromParams !== "{phone}"
					? phoneFromParams
					: window.localStorage.getItem("phone") || ""
			),
			maskaObject: reactive({
				unmasked: phoneFromParams ? phoneFromParams.replace(/\D/g, '') : '',
				completed: !phoneFromParams ? false : phoneFromParams.replace(/\D/g, '').length === 10 ? true : false
			}),
			submit: () => {
				localStorage.setItem('phone', questions.value.phone.value)

				if (questionOrder.value.indexOf('description') !== -1) {
					proceed()
				} else {
					submitLead()
				}
			}
		},
		address: {
			id: 'address',
			showHeadlines: false,
			showProgress: true,
			overrideValidation: false,
			validated: computed(() => {
				if (questions.value.address.overrideValidation) {
					return false
				}
				return (
					!questions.value.address.address ||
					!questions.value.address.zip) ? false : true
			}),
			type: 'address',
			chat: "<p>Additional loan options may apply based on where you live.</p>",
			address: ref(window.localStorage.getItem("address") ? window.localStorage.getItem("address") : ""),
			zip: ref(window.localStorage.getItem("zip") ? window.localStorage.getItem("zip") : ""),
			city: ref(window.localStorage.getItem("city") ? window.localStorage.getItem("city") : ""),
			state: ref(window.localStorage.getItem("state") ? window.localStorage.getItem("state") : ""),
			submit: () => {
				localStorage.setItem('address', questions.value.address.address)
				localStorage.setItem('zip', questions.value.address.zip)
				localStorage.setItem('city', questions.value.address.city)
				localStorage.setItem('state', questions.value.address.state)
				proceed()

				if (questions.value.email.sendtoAC) {
					let config = {
						method: 'post',
						maxBodyLength: Infinity,
						url: 'https://7nf2fxp2rksxslo4y5nlowihza0vidwh.lambda-url.us-east-2.on.aws/',
						headers: { 
							'Content-Type': 'application/json'
						},
						data : JSON.stringify({
							"email": questions.value.email.value,
							"state": questions.value.address.state,
							"zip": questions.value.address.zip,
							"faf": "1",
							"seed": "0"
						})
					};

					axios.request(config).then((response) => {
						console.log(response.data);
					}).catch((error) => {
						console.log(error);
					});
				}
			}
		},
		description: {
			id: 'description',
			headline: 'Briefly describe your debt and why you need relief',
			showHeadlines: false,
			showProgress: true,
			validated: computed(() => {
				return questions.value.description.value.length < 5 ? false : true
			}),
			type: 'openText',
			chat: "<p>Include details such as the amount and type of debt.</p>",
			value: ref(window.localStorage.getItem("description") ?  window.localStorage.getItem("description") : ""),
			submit: () => {
				localStorage.setItem('description', questions.value.description.value)
				submitLead()
			}
		}
	})

	// keep track of the currently displayed question and progress
	let currentProgress = ref(0)

	// used to briefly remove question to ensure smooth transitions
	let removeQuestion = ref(false)

	const getPostKeys = {
		'0': {
			lp_campaign_id: '66280997d0cd2',
			lp_campaign_key: 'zmv8MG2BhD6pJ3QWyLgr'
		}
	}
	
	// storing some general form data that we'll need upon submission
	const formData = {
		// lp_test: 1,
		ip_address: "",
		aff_id: params.has('aid') ? params.get('aid') : getCookie('aff_id') ? getCookie('aff_id') : "0",
		lp_s1: params.has('s1') ? params.get('s1') : params.has('sub1') ? params.get('sub1') : "",
		lp_s2: params.has('s2') ? params.get('s2') : params.has('sub2') ? params.get('sub2') : "",
		lp_s3: params.has('s3') ? params.get('s3') : params.has('sub3') ? params.get('sub3') : "",
		lp_s4: params.has('s4') ? params.get('s4') : params.has('sub4') ? params.get('sub4') : "",
		lp_s5: params.has('s5') ? params.get('s5') : "",
		user_agent: navigator.userAgent,
		lp_response: "json",
		landing_page: "https://firstadvantage.io/consolidate/"
	}
	console.log(formData)
	if (!getPostKeys[formData.aff_id]) {
		formData.aff_id = "0"
	}
	if (formData.aff_id !== "0") {
		setCookie('aff_id',formData.aff_id,7);
	}

	const isBlankOrUnknown = (v) =>
		!v || String(v).trim() === "" || String(v).trim().toLowerCase() === "unknown";

	async function ipstackFallback() {
		try {
			const resp = await axios.get("https://api.ipstack.com/check?access_key=df027d9a9416448d23a42df11a08961c");
			const d = resp.data || {};

			if (d.ip) formData.ip_address = d.ip;

			if (d.city) {
				backupCity = d.city;
			}
			if (d.region_code) {
				backupState = d.region_code;
			}
			if (d.zip) {
				backupZip = d.zip;
			}
		} catch (e) {
			console.error("Fallback ipstack /check failed:", e);
		}
	}

	async function getLocationData() {
		try {
			const response = await axios.get("https://fragrant-fog-f988.ryan-v-0b2.workers.dev/");
			const { ip, city, region, zip } = response.data || {};

			// Set IP / backups from Worker response
			formData.ip_address = ip || formData.ip_address || "Unknown";
			backupCity = city || "Unknown";
			backupState = region || "Unknown";
			backupZip = zip || "Unknown";

			// If Worker returned blanks/Unknowns, run ipstack fallback
			if (isBlankOrUnknown(backupCity) || isBlankOrUnknown(backupState)) {
				await ipstackFallback();
			}
		} catch (error) {
			console.error("Worker location fetch failed:", error);
			// On failure, run ipstack fallback
			await ipstackFallback();
		}
	}

	const getArrayData = () => {
		if (!formData.array_requested) {
			return
		}
		let config = {
			method: 'post',
			url: 'https://l4zw6nqbv5by2jukwdq6yz46py0wqjor.lambda-url.us-east-2.on.aws/',
			headers: {
				'Content-Type': 'application/json'
			},
			data: {
				firstName: questions.value.name.first,
				lastName: questions.value.name.last,
				address: {
					street: questions.value.address.address,
					city: questions.value.address.city ? questions.value.address.city : backupCity,
					state: questions.value.address.state ? questions.value.address.state : backupState,
					zip: questions.value.address.zip
				},
				dob: questions.value.dob.year + '-' + questions.value.dob.month + '-' + questions.value.dob.day,
				userConsent: {
					ipAddress: formData.ip_address,
					timestamp: new Date().toISOString(),
					url: formData.landing_page
				}
			}
		}
		axios.request(config).then((response) => {
			console.log(response.data);

			if (response.data !== null && typeof response.data === 'object') { // if the response is an object
				if (response.data.hasOwnProperty('results')) { // if the object contains results
					for (var key in response.data.results) { // for each key in the results object
						if (response.data.results.hasOwnProperty(key) && arrayData.hasOwnProperty(key)) { // if arrayData has the same key
							var result = response.data.results[key] // store the data object to simplify
							for (var resultKey in result) {
								if (result.hasOwnProperty(resultKey)) {
									if (result[resultKey]) {
										arrayData[key] = resultKey
									}
								}
							}
						}
					}
				}
			}

			if (questions.value.email.sendtoAC) {
				let config = {
					method: 'post',
					maxBodyLength: Infinity,
					url: 'https://7nf2fxp2rksxslo4y5nlowihza0vidwh.lambda-url.us-east-2.on.aws/',
					headers: { 
						'Content-Type': 'application/json'
					},
					data : JSON.stringify({
						"email": questions.value.email.value,
						"arrayDebt": arrayData.total_unsecured_debt,
						"creditScore": arrayData.credit_score,
						"collections": arrayData.collections,
						"delinquencies": arrayData.delinquencies,
						"taxLiens": arrayData.tax_liens,
						"studentLoans": arrayData.open_student_loan_bal,
						"birthYear": questions.value.dob.year,
						"birthMonth": questions.value.dob.month,
						"birthDay": questions.value.dob.day
					})
				};

				axios.request(config).then((response) => {
					console.log(response.data);
				}).catch((error) => {
					console.log(error);
				});
			}
		}).catch((error) => {
			console.log(error);
		});
	}

	// keep track of current progress percentage
	const progressPercent = computed(() => {
		return Math.round(((currentProgress.value + 1) / (questionOrder.value.length + 1)) * 100)
	})
	// store the currently active question object
	const currentQuestion = computed(() => {
		return questions.value[questionOrder.value[currentProgress.value]]
	})
	// boolean on whether or not we already stored location data from IP
	const hasLocationData = computed(() => {
		return questions.value.address.zip && questions.value.address.city && questions.value.address.state ? true : false
	})

	// is the transition moving forwards or backwards 1 question
	const transitionDirection = ref("forwards")
	// move forward 1 question
	function proceed() {
		transitionDirection.value = "forwards"
		removeQuestion.value = true

		window.setTimeout(function() {
			currentProgress.value++
			removeQuestion.value = false
			document.getElementById('header').scrollIntoView();

			// lets use hashing for state tracking
			history.pushState({currentProgress: currentProgress.value}, "", "#" + currentQuestion.value.id);

			localStorage.setItem('questionOrder', JSON.stringify(questionOrder.value))
		}, 10)
	}
	window.addEventListener("popstate", (event) => {
		if (event.state === null) {
			window.history.go(-1)
		} else {
			console.log(event.state)
			transitionDirection.value = currentProgress.value < event.state.currentProgress ? "forwards" : "backwards"
			removeQuestion.value = true

			window.setTimeout(function() {
				currentProgress.value = event.state.currentProgress
				removeQuestion.value = false
				document.getElementById('header').scrollIntoView();
				localStorage.setItem('questionOrder', JSON.stringify(questionOrder.value))
			}, 10)
		}
	});
	// move backwards 1 question
	function goBack() {
		history.back()
	}
	// hide or show the back button
	const backButtonVisible = ref(true)
	const hideBackButton = function() {
		backButtonVisible.value = false
	}
	const showBackButton = function() {
		backButtonVisible.value = true
	}
	// hide or show the tracking disclosure
	const trackingDisclosureVisible = ref(false)
	const hideTrackingDisclosure = function() {
		trackingDisclosureVisible.value = false
	}
	const showTrackingDisclosure = function() {
		trackingDisclosureVisible.value = true
	}
	const showDisclaimer = computed(() => {
		return ['kttd', 'ktt2', 'ktt3', 'ktt4', 'stt'].includes(formData.aff_id)
	})
	// hide or show the spinner during submission
	const showSpinner = ref(false)

	const displayThankYou = ref(false)

	const advertiser = ref("0")

	// --- External endpoints / constants ---
	const QUALIFI_URL = "https://4qmmgngigyryfn7ht6qa75z72y0mlnef.lambda-url.us-east-2.on.aws/";
	const QUALIFI_ENABLED = false; // force standard flow until Qualifi funnel returns
	const LEAD_POST_URL = "https://bluemodomedia.leadspediatrack.com/post.do";
	const LP_PIXEL_URL = "https://2u76bw6o7t3dpvhg45iwfoykvq0ewsgs.lambda-url.us-east-2.on.aws/&request_id=";
	const ADSRVR_URL = "https://insight.adsrvr.org/track/pxl/?adv=dvlf2yt&ct=0:aqpa200&fmt=3";

	// --- Formatting / mapping ---
	function toIsoDob(mm, dd, yyyy) {
		const m = String(mm).padStart(2, "0");
		const d = String(dd).padStart(2, "0");
		return `${yyyy}-${m}-${d}`;
	}
	function mapScoreToArrayCredit(score) {
		if (score < 500) return "credit_score_under_500";
		if (score <= 549) return "credit_score_500_549";
		if (score <= 599) return "credit_score_550_599";
		if (score <= 649) return "credit_score_600_649";
		if (score <= 699) return "credit_score_650_699";
		return "credit_score_over_699";
	}
	function mapDebtToVerified(debt) {
		if (debt < 10000) return 9949;
		if (debt < 15000) return 14999;
		if (debt < 20000) return 19999;
		if (debt < 30000) return 29999;
		if (debt <= 40000) return 40000;
		return 43499;
	}
	function shouldCallQualifi({ msg, verified_debt, income, revenue }) {
		const inc = String(income ?? "").trim();
		return (String(msg).toLowerCase() !== "duplicate") &&
			(Number(verified_debt) === 0) &&
			(inc !== "1500" && inc !== "0") &&
			(revenue < 1);
	}

	// --- Network calls ---
	async function postLeadOnce(dataObj) {
		_leadPostAttemptCounter += 1;
		const attempt = _leadPostAttemptCounter;

		const clean = buildFormPayload(dataObj);
		const postData = qs.stringify(clean);

		// PRE-POST log
		bsLog("lead.post.attempt", {
			attempt,
			lp_campaign_id: clean.lp_campaign_id,
			lp_campaign_key: (clean.lp_campaign_key || "").slice(0, 4) + "***",
			aff_id: clean.aff_id,
			array_credit: clean.array_credit,
			verified_debt: clean.verified_debt,
			og_source: clean.og_source,
			qualifi_verified: clean.qualifi_verified,
			has_jornaya: !!clean.jornaya_lead_id,
			has_trusted_form_id: !!clean.trusted_form_id,
			qs_len: postData.length,
		});

		const resp = await axios({
			method: "post",
			maxBodyLength: Infinity,
			url: LEAD_POST_URL,
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			data: postData,
		});

		// POST RESPONSE log
		bsLog("lead.post.response", {
			attempt,
			status: resp?.status,
			result: resp?.data?.result,
			msg: resp?.data?.msg,
			price: resp?.data?.price,
			lead_id: resp?.data?.lead_id,
			has_redirect_url: !!resp?.data?.redirect_url,
		});

		return resp;
	}

	async function fetchQualifiFromLambda({ firstName, lastName, email, phone, address, city, state, zip, dobISO }) {
		const payload = {
			FirstName: firstName,
			LastName: lastName,
			Email: email,
			Phone: phone,
			Address: address,
			City: city,
			State: state,
			Zip: zip,
			DOB: dobISO,
		};
		const t0 = performance.now();
		// helpful context for CORS/timeout triage
		bsLog("qualifi.begin", {
			origin: location.origin,
			ua: navigator.userAgent,
			// in case you ever tweak axios config
			axiosTimeout: 15000,
		});
		try {
			const resp = await axios.post(QUALIFI_URL, payload, {
				headers: { "Content-Type": "application/json" },
				timeout: 15000, // bump from 12000 to give cushion
				// validateStatus so we can still read body on non-2xx (not relevant for CORS/timeout)
				validateStatus: () => true,
			});

			const dt = Math.round(performance.now() - t0);
			bsLog("qualifi.end", { ok: resp.status >= 200 && resp.status < 300, status: resp.status, dt });

			// If server returned non-2xx, throw with detail so our catch path logs it
			if (!(resp.status >= 200 && resp.status < 300)) {
				const err = new Error(`HTTP ${resp.status}`);
				err.isAxiosError = true;
				err.response = resp;
				throw err;
			}

			if (!resp?.data || typeof resp.data.debtAmount !== "number" || typeof resp.data.creditScore !== "number") {
				const err = new Error("Qualifi response missing numbers");
				err.isAxiosError = true;
				err.response = { status: resp?.status, data: resp?.data };
				throw err;
			}

			return resp.data;
		} catch (e) {
			const dt = Math.round(performance.now() - t0);
			const info = explainAxiosError(e);
			bsLog("qualifi.error", { ...info, dt });
			throw e; // let your outer catch decide fallback flow
		}
	}

	// --- Small, focused side-effect helpers ---
	function setAdvertiserFromClients(clients) {
		if (!clients) return;
		for (let i = 0; i < clients.length; i++) {
			if (clients[i]?.client?.success === "true") {
				advertiser.value = String(clients[i].client.advertiserID);
				break;
			}
		}
	}
	function fireLpPixelIfNeeded(LpRequestId) {
		if (!LpRequestId) return;
		axios.post(LP_PIXEL_URL + LpRequestId).catch(() => {});
	}
	function sendAncillaryIfNeeded({ revenue }) {

		
	}
	function sendCallCenterIfNeeded({ revenue, result }) {
		if (revenue >= 2 || String(result).toLowerCase() === "duplicate") return;
		const url =
			"https://bluemodo.waypointsoftware.com/capture2.php" +
			`?xAuthentication=8ac67eabf731769da3eed05640fb1c87` +
			`&firstname=${encodeURIComponent(questions.value.name.first)}` +
			`&lastname=${encodeURIComponent(questions.value.name.last)}` +
			`&phone1=1${encodeURIComponent(questions.value.phone.maskaObject.unmasked)}` +
			`&city=${encodeURIComponent(questions.value.address.city)}` +
			`&state=${encodeURIComponent(questions.value.address.state)}` +
			`&zip=${encodeURIComponent(questions.value.address.zip)}` +
			`&email=${encodeURIComponent(questions.value.email.value)}`;
		axios.get(url, { maxBodyLength: Infinity }).catch(() => {});
	}
	function handleRedirects({ response, dataObj, revenue }) {
		let redirected = false;
		const url = response?.data?.redirect_url;
		if (url && url.substring(0, 8) === "https://") {
			if (readyToRedirect) {
			window.location.href = url.replace(/\\u0026/g, "&");
			} else {
			const redirectCheck = window.setInterval(function () {
				if (readyToRedirect) {
				clearInterval(redirectCheck);
				window.location.href = url.replace(/\\u0026/g, "&");
				}
			}, 300);
			}
			redirected = true;
			return;
		}

		if (
			advertiser.value === "2" ||
			(advertiser.value === "24" && Number(dataObj.verified_debt) > 1) ||
			advertiser.value === "30" ||
			(advertiserMapping[advertiser.value] && revenue > 1)
		) {
			displayThankYou.value = true;
		} else {
			// IMPORTANT: use the *current* payload for redirect logic
			triggerRedirect(dataObj, revenue, redirected);
		}
	}

	let _leadPostAttemptCounter = 0;

	function explainAxiosError(err) {
		// Axios vs non-Axios
		const isAxios = !!(err && err.isAxiosError);
		const out = {
			isAxios,
			name: err?.name,
			message: err?.message,
			code: err?.code,                 // e.g. 'ECONNABORTED' on timeout
			hasResponse: !!err?.response,
			status: err?.response?.status,   // HTTP status if any
			hasRequest: !!err?.request,      // true if network was attempted
			// keep payloads tiny
			responseType: err?.response?.type,
			responseTextSample: typeof err?.response?.data === "string"
			? err.response.data.slice(0, 200)
			: undefined,
		};
		return out;
	}

	// attempt lead submission
	const submitLead = function() {
		backButtonVisible.value = false
		showSpinner.value = true
		document.getElementById('header').scrollIntoView()

		let USDollar = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
		});

		// check if array debt matches lead response
		var arrayDebtResponse = arrayData.total_unsecured_debt;
		var creditScore = arrayData.credit_score;
		var collections = arrayData.collections;
		var delinquencies = arrayData.delinquencies;

		var noloArrayString = "";

		var verified_debt = 0;
		let openDescription = questions.value.description.value
		if (!openDescription || openDescription === "") {
			// openDescription = noloArrayString
		}
		// Build the initial payload
		const baseData = {
			...formData,
			'lp_campaign_id': getPostKeys[formData.aff_id].lp_campaign_id,
			'lp_campaign_key': getPostKeys[formData.aff_id].lp_campaign_key,
			'pd_company_id': getPostKeys[formData.aff_id].pd_company_id,
			'address': questions.value.address.address,
			'zip_code': questions.value.address.zip ? questions.value.address.zip : backupZip,
			'city': questions.value.address.city ? questions.value.address.city : backupCity,
			'state': questions.value.address.state ? questions.value.address.state : backupState,
			'email_address': questions.value.email.value,
			'first_name': questions.value.name.first,
			'last_name': questions.value.name.last,
			'phone_home': questions.value.phone.maskaObject.unmasked,
			'dob': `${questions.value.dob.month}/${questions.value.dob.day}/${questions.value.dob.year}`,
			'income': questions.value.income.value,
			'employed': questions.value.employed.value,
			'debt_amount': questions.value.amount.numberValue,
			'jornaya_lead_id': document.getElementById("leadid_token").value,
			'trusted_form_id': document.getElementsByName("xxTrustedFormToken")[0]
			? document.getElementsByName("xxTrustedFormToken")[0].value
			: "",
			'array_collections': arrayData.collections,
			'array_credit': arrayData.credit_score,
			'array_delinquencies': arrayData.delinquencies,
			'array_debt': arrayData.total_unsecured_debt,
			'array_tax_liens': arrayData.tax_liens,
			'array_student_loans': arrayData.open_student_loan_bal,
			'verified_debt': verified_debt,
			'description': questions.value.description.value || "",
			'own_real_estate': questions.value.realEstate.value ? questions.value.realEstate.value : false,
			'tcpaLanguage': questions.value.phone.tcpaLanguage || ''
		};
		if (LpRequestId) baseData.lp_request_id = LpRequestId;
		
		// === Core pipeline ===
		const runStandardFlow = async ({ response, dataObj }) => {
			bsLog("flow.standard", { attempt: _leadPostAttemptCounter });
			const result = response?.data?.result;
			const msg = response?.data?.msg;
			lpLeadId = response?.data?.lead_id;
			const revenue = Number(response?.data?.price);

			let isDuplicate = false;

			if (msg === "Lead Rejected" && Array.isArray(response?.data?.errors)) {
				// Look for any "Duplicate" keyword in the errors array
				isDuplicate = response.data.errors.some((e) =>
					typeof e?.error === "string" && e.error.toLowerCase().includes("duplicate")
				);
			}

			if (result === "success" && msg === "Lead Accepted") {
				setAdvertiserFromClients(response?.data?.clients);
				fireLpPixelIfNeeded(LpRequestId);
			}

			sendAncillaryIfNeeded({ revenue });
			if (!isDuplicate) {
				sendCallCenterIfNeeded({ revenue, result });
			}
			handleRedirects({ response, dataObj, revenue });
		};

		const handleLeadResponse = async ({ response, dataObj, allowQualifi }) => {
			const result = response?.data?.result;
			const msg = response?.data?.msg;
			const revenue = Number(response?.data?.price ?? 0);

			let isDuplicate = false;

			if (msg === "Lead Rejected" && Array.isArray(response?.data?.errors)) {
				// Look for any "Duplicate" keyword in the errors array
				isDuplicate = response.data.errors.some((e) =>
				typeof e?.error === "string" && e.error.toLowerCase().includes("duplicate")
				);
			}

			// Gate log
			bsLog("flow.gate", {
				attempt: _leadPostAttemptCounter,
				allowQualifi,
				msg,
				revenue,
				isDuplicate,
    			rawErrors: response?.data?.errors,
				verified_debt: dataObj.verified_debt,
				income: dataObj.income,
			});

			if (isDuplicate) {
				console.warn("⚠️ Lead rejected due to duplicate:", dataObj.email_address);
				// Handle duplicates however you want (no Qualifi, no repost, etc.)
				return runStandardFlow({ response, dataObj });
			}

			if (QUALIFI_ENABLED && allowQualifi && shouldCallQualifi({ msg, verified_debt: dataObj.verified_debt, income: dataObj.income, revenue })) {
				try {
					// ✳️ enable runtime logging *now* (only for users that actually hit Qualifi)
					bsEnable();
					const dobISO = toIsoDob(questions.value.dob.month, questions.value.dob.day, questions.value.dob.year);

					// Qualifi request log (sanitized)
					bsLog("qualifi.request", {
						FirstName: dataObj.first_name,
						LastName: dataObj.last_name,
						Email: dataObj.email_address,
						Phone: dataObj.phone_home,
						Address: dataObj.address,
						City: dataObj.city,
						State: dataObj.state,
						Zip: dataObj.zip_code,
						DOB: dobISO,
					});

					const qualifi = await fetchQualifiFromLambda({
						firstName: dataObj.first_name,
						lastName: dataObj.last_name,
						email: dataObj.email_address,
						phone: dataObj.phone_home,
						address: dataObj.address,
						city: dataObj.city,
						state: dataObj.state,
						zip: dataObj.zip_code,
						dobISO,
					});

					// Qualifi response log
					bsLog("qualifi.response", {
						debtAmount: qualifi.debtAmount,
						creditScore: qualifi.creditScore,
					});

					const mapped = {
						array_credit: mapScoreToArrayCredit(qualifi.creditScore),
						verified_debt: mapDebtToVerified(qualifi.debtAmount),
					};

					// Build re-post payload
					const newData = {
						...dataObj,
						'lp_campaign_id': "68ee532348352",
						'lp_campaign_key': "Kr82qXGRzmhZLPNMjk73",
						'array_credit': mapped.array_credit,
						'verified_debt': mapped.verified_debt,
						'og_source': dataObj.aff_id,
						'qualifi_verified': "Yes",
					};

					// Re-post payload preview
					const newClean = buildFormPayload(newData);
					const newQs = qs.stringify(newClean);
					bsLog("qualifi.repost.payload", {
						lp_campaign_id: newClean.lp_campaign_id,
						lp_campaign_key: (newClean.lp_campaign_key || "").slice(0, 4) + "***",
						array_credit: newClean.array_credit,
						verified_debt: newClean.verified_debt,
						og_source: newClean.og_source,
						qualifi_verified: newClean.qualifi_verified,
						qs_len: newQs.length,
					});

					// SECOND PASS (qualifi-enriched)
					return await processLead(newData, { allowQualifi: false });
				} catch (e) {
					bsLog("qualifi.error", { message: e?.message || String(e) }, "error");
					// fall through to standard flow
				}
			}

			// Standard end-of-pipeline flow (runs in both passes)
			return runStandardFlow({ response, dataObj });
		};


		const processLead = async (dataObj, { allowQualifi }) => {
			// const response = await postLeadOnce(dataObj);
			// return handleLeadResponse({ response, dataObj, allowQualifi });
			displayThankYou.value = true;
		};

		processLead(baseData, { allowQualifi: true })
			.catch(err => {
			console.error("submitLead error", err);
			// optional: UI cleanup here if needed
			});
	};

	function triggerRedirect(data, revenue, redirected, called=false) {
		sendToEzsend(data)
		// axios.get('https://bluemodo.waypointsoftware.com/capture3.php?xAuthentication=505fab381163fd6997cb9424ccafeb48&phone1=' + data.phone_home + '&firstname=' + data.first_name + '&lastname=' + data.last_name + '&email=' + data.email_address + '&zip=' + data.zip_code + '&trustedform=' + data.trusted_form_id + '&xleadid=' + lpLeadId + '&jornaya=' + data.jornaya_lead_id + '&state=' + data.state + '&ipaddress=' + data.ip_address + '&landing_page_url=' + data.landing_page);
		// if (Math.random() < 0.5) {
		// 	window.location.href = "https://firstadvantage.io/programs/"
		// } else {
		// 	window.location.href = "https://firstadvantage.io/programs/save.html"
		// }

		let turboLink = "https://www.ab92trk.com/2X2ZMNN/45TJ3T/?sub1=fa1&sub2="
		if (called) {
			turboLink = "https://www.ab92trk.com/2X2ZMNN/6FQ5XR/?sub1=fa2&sub2="
		}

		let redirectUrlCustom = "https://firstadvantage.io/programs/save.html?vd=" + data.verified_debt.toString()
		if (data.verified_debt === 9949) {
			redirectUrlCustom = turboLink + (data.aff_id || '') + "&first=" + (data.first_name || '') + "&last=" + (data.last_name || '') + "&phone=" + (questions.value.phone.maskaObject.unmasked || '') + "&email=" + (data.email_address || '') + "&state=" + (data.state || '');
		} else if (data.verified_debt === 0 && revenue < 1) {
			redirectUrlCustom = turboLink + (data.aff_id || '') + "&first=" + (data.first_name || '') + "&last=" + (data.last_name || '') + "&phone=" + (questions.value.phone.maskaObject.unmasked || '') + "&email=" + (data.email_address || '') + "&state=" + (data.state || '');
		} else if (data.verified_debt > 10000 && revenue < 1) {
			redirectUrlCustom = turboLink + (data.aff_id || '') + "&first=" + (data.first_name || '') + "&last=" + (data.last_name || '') + "&phone=" + (questions.value.phone.maskaObject.unmasked || '') + "&email=" + (data.email_address || '') + "&state=" + (data.state || '');
		}
		if (!redirected) {
			if (readyToRedirect) {
				window.location.href = redirectUrlCustom
			} else {
				let redirectCheck = window.setInterval(function() {
					if (readyToRedirect) {
						clearInterval(redirectCheck)
						window.location.href = redirectUrlCustom
					}
				}, 300)
			}
		}
	}

	const redirectUrl = computed(() => {
		let ac = acContactId ? 'Yes' : 'No'
		return "https://firstadvantage.io/?lid=" + lpLeadId + "&aid=" + formData.aff_id + "&ac=" + ac
	})

	onMounted(() => {
		// trusted form
		(function() {
            var field = 'xxTrustedFormCertUrl';
            var provideReferrer = false;
            var invertFieldSensitivity = false;
            var tf = document.createElement('script');
            tf.type = 'text/javascript'; tf.async = true; tf.defer = true;
            tf.src = 'http' + ('https:' == document.location.protocol ? 's' : '') +
              '://api.trustedform.com/trustedform.js?provide_referrer=' + escape(provideReferrer) + '&field=' + escape(field) + '&l='+new Date().getTime()+Math.random() + '&invert_field_sensitivity=' + invertFieldSensitivity;
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(tf, s); }
        )();

		if (getPostKeys[formData.aff_id].hasOwnProperty('everflow_aff_id')) {
			let EfAffId = getPostKeys[formData.aff_id]['everflow_aff_id']
			let EFscript = document.createElement('script');
			EFscript.type = 'text/javascript';
			EFscript.async = true;
			EFscript.onload = function(){
				EF.click({
					offer_id: getPostKeys[formData.aff_id]['everflow_offer_id'] ? getPostKeys[formData.aff_id]['everflow_offer_id'] : 320, // Required. The offer id
					affiliate_id: EfAffId, //Required. The affiliate id

					// Optional. Sub placement values.
					sub1: EF.urlParameter('s1'),
					sub2: params.has('reid') ? EF.urlParameter('reid') : EF.urlParameter('s2'),
					sub3: EF.urlParameter('s3'),
					sub4: EF.urlParameter('s4'),
					sub5: EF.urlParameter('s5'),
				}).then((transactionId) => {
					formData.lp_s5 = transactionId;

					// track clicks if this is a bucket setup campaign
					if (getPostKeys[formData.aff_id].hasOwnProperty('click_campaign_id')) {
						console.log('click pixel')
						console.log(getPostKeys[formData.aff_id]['click_campaign_id'])
						let LpClickScript = document.createElement('script');
						LpClickScript.type = 'text/javascript';
						LpClickScript.async = true;
						LpClickScript.onload = function(){
							LpRequestId = lp_request_id
							console.log(LpRequestId)
						};
						LpClickScript.src = 'https://bluemodomedia.leadspediatrack.com/?c=' + getPostKeys[formData.aff_id]['click_campaign_id'] + '&t=p&s5=' + formData.lp_s5 + '&s2=' + formData.lp_s2;
						document.getElementsByTagName('head')[0].appendChild(LpClickScript);
					}
				});
			};
			EFscript.src = 'https://www.fpplk8trk.com/scripts/sdk/everflow.js';
			document.getElementsByTagName('head')[0].appendChild(EFscript);
		} else if (getPostKeys[formData.aff_id].hasOwnProperty('click_campaign_id')) {
			console.log('click pixel')
			console.log(formData.lp_s5)
			console.log(getPostKeys[formData.aff_id]['click_campaign_id'])
			let LpClickScript = document.createElement('script');
			LpClickScript.type = 'text/javascript';
			LpClickScript.async = true;
			LpClickScript.onload = function(){
				if (lp_request_id) {
					LpRequestId = lp_request_id
					console.log(LpRequestId)
				}
			};
			LpClickScript.src = 'https://bluemodomedia.leadspediatrack.com/?c=' + getPostKeys[formData.aff_id]['click_campaign_id'] + '&t=p&s5=' + formData.lp_s5 + '&s2=' + formData.lp_s2;
			document.getElementsByTagName('head')[0].appendChild(LpClickScript);
		}

		if (window.location.hash) {
			// start by checking for stored question order
			let updatedQuestionOrder = localStorage.getItem('questionOrder')
			if (!updatedQuestionOrder) {
				return
			}
			questionOrder.value = JSON.parse(updatedQuestionOrder)

			// start by checking which question we're on
			let updatedProgress = questionOrder.value.indexOf(window.location.hash.replace('#',''))

			if (updatedProgress !== -1) {
				// we need to make sure we have all the data up to this point.
				for (var i = 0; i<updatedProgress; i++) {
					// if the question is contact we'll need to handle the 2 fields individually
					if (questions.value[questionOrder.value[i]].id === 'name') {
						if (questions.value.name.first === null ||
							questions.value.name.last === null) {
							updatedProgress = i
							break
						}
					} else { // otherwise we can just check to make sure there is a value
						if (questions.value[questionOrder.value[i]].value === null || questions.value[questionOrder.value[i]].value === "") {
							updatedProgress = i
							break
						}
					}
					history.pushState({currentProgress: i}, "", "#" + questions.value[questionOrder.value[i]].id);
				}
				// Now move forward to the correct question
				currentProgress.value = updatedProgress

				if (questions.value.name.first !== null && questions.value.name.first !== "") {
					getLocationData()
				}

				if (questions.value.dob.day !== null) {
					// wait for IP address
					if (formData.ip_address !== "") {
						// getArrayData()
					} else {
						let waitForIp = window.setInterval(function() {
							if (formData.ip_address !== "") {
								clearInterval(waitForIp)
								// getArrayData()
							}
						}, 500)
					}
					
				}
			}
		}

		history.pushState({currentProgress: currentProgress.value}, "", "#" + currentQuestion.value.id);
	})
</script>

<template>
	<Header
		:progressPercent="progressPercent"
		:showProgress="currentQuestion.showProgress"
		:backButtonVisible="backButtonVisible"
		:advertiser="advertiser"
		:showDisclaimer="showDisclaimer"
		@showTrackingDisclosure="showTrackingDisclosure"
		@goBack="goBack" />
	<Main
		v-if="!showSpinner && !displayThankYou"
		:question="currentQuestion"
		:removeQuestion="removeQuestion"
		:direction="transitionDirection"
		:backButtonVisible="backButtonVisible"
		:firstName="questions.name.first"
		:mainHeadline="mainHeadline"
		:mainSubHeadline="mainSubHeadline"
		:showArrayDisclaimer="showArrayDisclaimer"
		:trackingDisclosureVisible="trackingDisclosureVisible"
		@showTrackingDisclosure="showTrackingDisclosure"
		@hideTrackingDisclosure="hideTrackingDisclosure"
		@proceed="currentQuestion.submit"
		@goBack="goBack"
		@hideBackButton="hideBackButton"
		@showBackButton="showBackButton" />
	<section v-else-if="showSpinner && !displayThankYou" class="spinnerContainer">
		<Spinner :messages="['Verifying your information...','Checking if you qualify...','Calculating your savings...','Validating results...','Looking for more savings...','Almost there!']" />
	</section>
	<Thankyou
		v-else-if="displayThankYou"
		:advertiser="advertiser"
	/>
	<Footer />
</template>

<style scoped>
	.spinnerContainer {
		min-height: 550px;
        min-height: 70vh;
        position: relative;
		padding-top: 50px;
	}
</style>
